// export const LOCAL_URL = 'https://bits-api.herokuapp.com/'
// export const URL = 'http://35.200.67.67/v1/admin/' // Production env
// export const URL = 'http://app.buffalo-its.jp/v1/admin/' // HTTPS Production env

export const URL = process.env.REACT_APP_STAGE === 'production' ? 'https://app.buffalo-its.jp/api/v1/admin/' : 'https://api.cloud.finewerk.net/api/v1/admin/'
export const TOKEN_URL = process.env.REACT_APP_STAGE === 'production' ? 'https://app.buffalo-its.jp/api/v1/admin/' : 'https://bits-api.herokuapp.com/'

// export const BASE_URL = 'http://35.221.119.172/'
// export const HEROKU_URL = 'https://bits-api.herokuapp.com/'

const PROD_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBPzMPwVwXyGTWqm3IXQSWabnYRMiwwtcQ',
  authDomain: 'bits-4c34b.firebaseapp.com',
  databaseURL: 'https://bits-4c34b.firebaseio.com',
  projectId: 'bits-4c34b',
  storageBucket: 'bits-4c34b.appspot.com',
  messagingSenderId: '546102546054'
}
const DEV_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB6Tx2fM8NEFf1idOu2gZWqaj9BaZE6OUU',
  authDomain: 'fb-bits-dev.firebaseapp.com',
  databaseURL: 'https://fb-bits-dev.firebaseio.com',
  projectId: 'fb-bits-dev',
  storageBucket: 'fb-bits-dev.appspot.com',
  messagingSenderId: '1062353974166'
}
export const FIREBASE_CONFIG = process.env.REACT_APP_STAGE === 'production' ? PROD_FIREBASE_CONFIG : DEV_FIREBASE_CONFIG

export const PREFECTURES = [
  {
    'code': 1,
    'name': '北海道'
  },
  {
    'code': 2,
    'name': '青森県'
  },
  {
    'code': 3,
    'name': '岩手県'
  },
  {
    'code': 4,
    'name': '宮城県'
  },
  {
    'code': 5,
    'name': '秋田県'
  },
  {
    'code': 6,
    'name': '山形県'
  },
  {
    'code': 7,
    'name': '福島県'
  },
  {
    'code': 8,
    'name': '茨城県'
  },
  {
    'code': 9,
    'name': '栃木県'
  },
  {
    'code': 10,
    'name': '群馬県'
  },
  {
    'code': 11,
    'name': '埼玉県'
  },
  {
    'code': 12,
    'name': '千葉県'
  },
  {
    'code': 13,
    'name': '東京都'
  },
  {
    'code': 14,
    'name': '神奈川県'
  },
  {
    'code': 15,
    'name': '新潟県'
  },
  {
    'code': 16,
    'name': '富山県'
  },
  {
    'code': 17,
    'name': '石川県'
  },
  {
    'code': 18,
    'name': '福井県'
  },
  {
    'code': 19,
    'name': '山梨県'
  },
  {
    'code': 20,
    'name': '長野県'
  },
  {
    'code': 21,
    'name': '岐阜県'
  },
  {
    'code': 22,
    'name': '静岡県'
  },
  {
    'code': 23,
    'name': '愛知県'
  },
  {
    'code': 24,
    'name': '三重県'
  },
  {
    'code': 25,
    'name': '滋賀県'
  },
  {
    'code': 26,
    'name': '京都府'
  },
  {
    'code': 27,
    'name': '大阪府'
  },
  {
    'code': 28,
    'name': '兵庫県'
  },
  {
    'code': 29,
    'name': '奈良県'
  },
  {
    'code': 30,
    'name': '和歌山県'
  },
  {
    'code': 31,
    'name': '鳥取県'
  },
  {
    'code': 32,
    'name': '島根県'
  },
  {
    'code': 33,
    'name': '岡山県'
  },
  {
    'code': 34,
    'name': '広島県'
  },
  {
    'code': 35,
    'name': '山口県'
  },
  {
    'code': 36,
    'name': '徳島県'
  },
  {
    'code': 37,
    'name': '香川県'
  },
  {
    'code': 38,
    'name': '愛媛県'
  },
  {
    'code': 39,
    'name': '高知県'
  },
  {
    'code': 40,
    'name': '福岡県'
  },
  {
    'code': 41,
    'name': '佐賀県'
  },
  {
    'code': 42,
    'name': '長崎県'
  },
  {
    'code': 43,
    'name': '熊本県'
  },
  {
    'code': 44,
    'name': '大分県'
  },
  {
    'code': 45,
    'name': '宮崎県'
  },
  {
    'code': 46,
    'name': '鹿児島県'
  },
  {
    'code': 47,
    'name': '沖縄県'
  }
]

export const deleteMsg = '削除しますか？'
export const smsMessage = '以下のURLより「つなるむ」をダウンロードいただき、ご登録お願い致します\niOS: http://bit.ly/2R7VD4X\nAndroid: http://bit.ly/2q7XXNR'

export const GUID = function () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export const GARBAGE_CATEGORIES = [
  {
    id: 0,
    name: '可燃ごみ',
    color: '#e55039'
  },
  {
    id: 1,
    name: '不燃ごみ',
    color: '#4a69bd'
  },
  {
    id: 2,
    name: '資源ごみ',
    color: '#78e08f'
  },
  {
    id: 3,
    name: '粗大ごみ',
    color: '#f19066'
  },
  {
    id: 4,
    name: 'プラスチック製容器包装',
    color: '#574b90'
  },
  {
    id: 5,
    name: 'ペットボトル',
    color: '#38ada9'
  },
  {
    id: 6,
    name: '空きびん',
    color: '#82ccdd'
  },
  {
    id: 7,
    name: '空き缶',
    color: '#63cdda'
  },
  {
    id: 8,
    name: '古紙',
    color: '#fad390'
  },
  {
    id: 9,
    name: '古着・古布',
    color: '#f8a5c2'
  },
  {
    id: 10,
    name: '金属類',
    color: '#f5cd79'
  },
  {
    id: 11,
    name: '',
    color: ''
  },
  {
    id: 12,
    name: '',
    color: ''
  },
  {
    id: 13,
    name: '',
    color: ''
  }

]



// WEBPACK FOOTER //
// ./src/const/index.js